import React from 'react';
import { useTranslation } from '@testsigma/atoms';

interface LoadDebuggerPageProps {}
export const LoadDebuggerPage: React.FC<LoadDebuggerPageProps> = () => {
  const { t } = useTranslation();
  return (
    <div className='flex flex-col gap-y-5 items-center'>
      <div className='empty-page-loader mt-[25%] mx-auto' />
      <div className='text-secondary-unique-800 w-fit'>
        {t('dubugging.web.testsigma.load_debugger')}
      </div>
    </div>
  );
};
